import React from 'react';
import AuthRoutes from '../routes/AuthRoutes';
import AuthShell from '../components/auth/AuthShell';

const AuthBasicLayout = () => (
  <AuthShell>
    <div className="fs--1 font-weight-normal">
      <AuthRoutes />
    </div>
  </AuthShell>
);

export default AuthBasicLayout;
